/**
 * <precommande-countdown> — compte à rebours de fin de précommande.
 *
 * Attend un attribut `data-deadline` au format local ISO (ex. "2026-08-01T00:00").
 * Met à jour toutes les secondes les cellules jours / heures / minutes / secondes.
 * Lorsque l'échéance est atteinte, l'attribut `data-expired` est ajouté afin de
 * pouvoir afficher un message alternatif via le CSS/Liquid.
 */
class PrecommandeCountdown extends HTMLElement {
  connectedCallback() {
    const raw = (this.dataset.deadline || '').trim();
    // Normalise "YYYY-MM-DD HH:MM" -> "YYYY-MM-DDTHH:MM" pour un parsing fiable.
    this.deadline = raw ? new Date(raw.replace(' ', 'T')).getTime() : Number.NaN;

    this.cells = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    if (Number.isNaN(this.deadline)) return;

    this.#tick();
    this.timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
  }

  #tick() {
    const diff = this.deadline - Date.now();

    if (diff <= 0) {
      window.clearInterval(this.timer);
      this.#render(0, 0, 0, 0);
      this.dataset.expired = '';
      return;
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.#render(days, hours, minutes, seconds);
  }

  /**
   * @param {number} days
   * @param {number} hours
   * @param {number} minutes
   * @param {number} seconds
   */
  #render(days, hours, minutes, seconds) {
    const pad = (value) => String(value).padStart(2, '0');
    if (this.cells.days) this.cells.days.textContent = pad(days);
    if (this.cells.hours) this.cells.hours.textContent = pad(hours);
    if (this.cells.minutes) this.cells.minutes.textContent = pad(minutes);
    if (this.cells.seconds) this.cells.seconds.textContent = pad(seconds);
  }
}

if (!customElements.get('precommande-countdown')) {
  customElements.define('precommande-countdown', PrecommandeCountdown);
}
